<!-- MODAL observacionesModal -->
<div mdbModal #observacionesModal="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <form [formGroup]="formData" (ngSubmit)="guardar()" novalidate>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Ingrese Observaciones (Hasta 300 caracteres)
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="observacionesModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="observaciones" class="form-control"
                  placeholder="Escribe aquí las observaciones" required #observaciones formControlName="observaciones" />
                <label for="observaciones">Observaciones</label>
                <div *ngIf="
                    formData.get('observaciones').invalid &&
                    (formData.get('observaciones').dirty ||
                    formData.get('observaciones').touched)
                  ">
                  <mdb-error *ngIf="formData.get('observaciones').hasError('required')">Ingrese observaciones
                  </mdb-error>
                  <mdb-error *ngIf="formData.get('observaciones').hasError('max')">Texto debe tener un largo máximo de
                    300 caracteres
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
            (click)="observacionesModal.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <button size="sm" type="submit" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
